import type { ComponentType, ReactNode } from 'react';
import { Suspense } from 'react';

export const withSuspense = <T,>(Component: ComponentType<T>, placeholder?: ReactNode) => {
  const LazyComponent = (props: T) => (
    <Suspense fallback={placeholder}>
      <Component {...props} />
    </Suspense>
  );
  return LazyComponent;
};
